import React from 'react';
import { Text } from '~/components/atomic';
import { case_note1, case_note2 } from '~/constants/mystery';
import ClueNoteBG from '~/assets/img/chat/mystery/clue_note.png';
import ClueNoteTitle from '~/assets/img/chat/mystery/clue_note_title.png';
import { useMysteryChatStore } from '~/store';
import * as S from './ClueNoteModal.styled';

interface ClueNoteModalProps {
  title: string | undefined;
}

export default function ClueNoteModal({ title }: ClueNoteModalProps) {
  const { showCaseNotes, setShowCaseNotes } = useMysteryChatStore((state) => ({
    showCaseNotes: state.showCaseNotes,
    setShowCaseNotes: state.setShowCaseNotes,
  }));

  const case_note = title === 'Who killed Dr.Chen?' ? case_note1 : case_note2;

  const handleModalClose = () => {
    setShowCaseNotes(false);
  };

  return (
    <>
      {title && showCaseNotes && (
        <>
          <S.Container>
            <S.Inner>
              <S.ClueNote>
                <S.ClueNotePaperBackground
                  src={ClueNoteBG}
                  alt='clue_note_background'
                />
                <S.Content>
                  <S.ClueTitle>
                    <img src={ClueNoteTitle} alt='clue_note_title' />
                  </S.ClueTitle>
                  <S.ClueListBox>
                    {Object.entries(case_note).map(([key, value], index) => (
                      <S.ClueList key={index}>
                        <Text
                          as={'p'}
                          fontStyle='text.body14_bold'
                          color='content_dark_1'
                        >
                          {key}
                        </Text>
                        <S.ClueDesc>
                          <Text
                            as={'p'}
                            fontStyle='text.body14_medium'
                            color='content_dark_1'
                          >
                            {value.split('/n').map((line, i) => (
                              <React.Fragment key={i}>
                                {line}
                                <br />
                              </React.Fragment>
                            ))}
                          </Text>
                        </S.ClueDesc>
                      </S.ClueList>
                    ))}
                  </S.ClueListBox>
                </S.Content>
              </S.ClueNote>

              <S.CloseButtonBox>
                <button onClick={handleModalClose}>
                  <Text
                    as={'span'}
                    fontStyle='title.section18_medium'
                    color='content_dark_1'
                  >
                    Close
                  </Text>
                </button>
              </S.CloseButtonBox>
            </S.Inner>
          </S.Container>
          <S.Background onClick={handleModalClose} className='background' />
        </>
      )}
    </>
  );
}
